import { render } from "./EditBundleModal.vue?vue&type=template&id=5ad90938"
import script from "./EditBundleModal.vue?vue&type=script&lang=js"
export * from "./EditBundleModal.vue?vue&type=script&lang=js"

import "./EditBundleModal.vue?vue&type=style&index=0&id=5ad90938&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__